import { capturePosition, restorePosition, changesAfter, patchCustomers, syncCustomers } from './customer-sync'

export default function paged(endpoint, key, params, customerSync = false) {
  return {
    data() {
      return {
        list: [],
        page: 1,
        total: 0,
        loading: false,
        fetching: false,
        finished: false,
        error: '',
        syncing: false,
        syncError: '',
        customerVersion: 0
      }
    },
    created() {
      const cache = this.$store.state.views[key]
      const signature = JSON.stringify(params.call(this))
      if (cache && cache.signature === signature && cache.revision === this.$store.state.revision) {
        this.list = cache.list
        this.page = cache.page
        this.total = cache.total
        this.finished = cache.finished
        this.customerVersion = cache.customerVersion || 0
        if (typeof cache.filter === 'string' && typeof this.filter === 'string')
          this.filter = cache.filter
        restorePosition(this, cache)
        if (customerSync && changesAfter(this.$store, this.customerVersion).length) {
          // Pause the infinite list before mounting; otherwise it can append a page while reconciliation is pending.
          this.syncing = true
          this.$nextTick(() => window.requestAnimationFrame(() => { this.syncing = false; this.syncChangedCustomers() }))
        }
      } else {
        this.customerVersion = this.$store.state.customerRevision
        this.loadMore()
      }
    },
    beforeRouteLeave(to, from, next) {
      this.$store.state.views[key] = {
        list: this.list,
        page: this.page,
        total: this.total,
        finished: this.finished,
        ...capturePosition(),
        customerVersion: this.customerVersion,
        revision: this.$store.state.revision,
        signature: JSON.stringify(params.call(this)),
        filter: this.filter
      }
      next()
    },
    methods: {
      async loadMore() {
        if (this.fetching || this.finished || this.syncing) { this.loading = this.fetching; return }
        this.fetching = true
        this.loading = true
        this.error = ''
        const requestParams = Object.assign({}, params.call(this), { page: this.page })
        const version = this.$store.state.customerRevision
        if (customerSync) { requestParams.loaded_ids = this.list.map(item => Number(item.id)); requestParams.page = 1 }
        try {
          const data = await this.$api.post(endpoint, requestParams)
          if (this._isDestroyed) return
          if (customerSync && version !== this.$store.state.customerRevision) return
          const items = data.data || []
          const pagination = data.meta && data.meta.pagination
          const sync = data.meta && data.meta.sync
          const known = {}
          this.list.forEach(item => {
            known[item.id] = true
          })
          this.list = this.list.concat(items.filter(item => !known[item.id]))
          this.total = sync ? sync.total : pagination ? pagination.total : this.list.length
          this.finished = sync ? sync.finished : pagination
            ? pagination.current_page >= pagination.total_pages
            : items.length < 20
          this.page++
        } catch (e) {
          this.error = e.message
        } finally {
          this.fetching = false
          this.loading = false
          if (customerSync && !this._isDestroyed && version !== this.$store.state.customerRevision) this.syncChangedCustomers()
        }
      },
      async syncChangedCustomers() {
        if (!customerSync || this.syncing || this._isDestroyed) return
        const version = this.$store.state.customerRevision
        const changes = changesAfter(this.$store, this.customerVersion)
        if (!changes.length) return
        this.syncing = true
        this.syncError = ''
        const initial = this.list
        const position = capturePosition()
        this.list = patchCustomers(this.list, changes)
        restorePosition(this, position)
        try {
          const result = await syncCustomers(this.$api, endpoint, params.call(this), this.list, changes)
          if (this._isDestroyed || version !== this.$store.state.customerRevision) return
          const anchor = capturePosition()
          this.list = result.list
          this.total = result.total
          // An edit can introduce more matches beyond a previously finished list.
          this.finished = this.list.length >= this.total
          this.customerVersion = version
          restorePosition(this, anchor)
          if (result.removed.length && initial.some(row => result.removed.indexOf(row.id) >= 0)) this.$toast(key === 'reminders' ? '已保存，已移出到期列表' : '客户已更新，已移出当前筛选列表')
        } catch (e) {
          if (!this._isDestroyed) this.syncError = '客户已保存，列表状态暂未同步'
        } finally {
          this.syncing = false
          if (!this._isDestroyed && version !== this.$store.state.customerRevision) this.syncChangedCustomers()
        }
      },
      reloadList() {
        if (this.fetching || this.syncing) return
        this.list = []
        this.page = 1
        this.finished = false
        this.total = 0
        this.error = ''
        this.syncError = ''
        this.customerVersion = this.$store.state.customerRevision
        this.loadMore()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/paged.js